import React, { FC } from 'react';
import styled from '@mui/styles/styled';
import { QuickFilter } from './QuickFilter';
import { useTranslation } from 'react-i18next';

export interface IQuickFilter {
  filterField?: string;
  filterOp?: string;
  filterVal?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  isDefault?: boolean;
  isVisible?: boolean;
  extra?: Record<string, undefined | string>;
}

export interface IQuickFiltersProps {
  quickFilters: Map<string, IQuickFilter>;
}

const QuickFiltersContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  color: theme.palette.text.disabled,
}));

export const QuickFilters: FC<IQuickFiltersProps> = ({ quickFilters }) => {
  const { t } = useTranslation();

  return (
    <QuickFiltersContainer data-cy={'quickfilters'}>
      {t('component.easyFilter.quickFiltersLabel')}:
      {Array.from(quickFilters)
        .filter(([, { isVisible }]) => isVisible !== false)
        .map(([label, filter]) => {
          return <QuickFilter key={label} label={label} {...filter} />;
        })}
    </QuickFiltersContainer>
  );
};
